import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import type { PDFDocumentProxy } from "pdfjs-dist";
import "./create-pdf.scss";
import "pdfjs-dist/build/pdf.worker.min.mjs";

pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs",import.meta.url,).toString();

export interface IPDF {
  data: Blob | undefined,
}

export const Preview = (props: IPDF) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [ pagesAmount, setPagesAmount] = useState<number>(0);

  function onDocumentLoadSuccess({ numPages: nextNumPages }: PDFDocumentProxy): void {
    setPagesAmount(nextNumPages);
  }
  return (
    <div>
      <Document onLoadSuccess={onDocumentLoadSuccess} file={props.data}>
        <Page pageNumber={pageNumber} />
      </Document>

      <div className="createPdf-arrows-group">
        <span className="createPdf-arrow" onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}>
          <BsArrowLeft />
        </span>
        <span className="createPdf-arrow" onClick={() => {
          const newNum = pageNumber + 1;
          setPageNumber(newNum < pagesAmount? pageNumber + 1 : pagesAmount);
        }}>
          <BsArrowRight />
        </span>
      </div>
    </div>
  );
};
